export const ValidatePasswordDirectiveModule = angular
    .module('app.directives.validatePassword', [])
    .directive('vlnValidatePassword', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, ele, attrs, modelCtrl) => {
                modelCtrl.$validators.validPassword = (pass) => {
                    if (!pass) return true;
                    let hasUppercase = /[A-Z]/.test(pass);
                    let hasLowercase = /[a-z]/.test(pass);
                    let hasNumberOrSpecial = /[0-9]|[^A-Za-z0-9]/.test(pass);

                    return hasUppercase && hasLowercase && hasNumberOrSpecial;
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/validatePassword.directive.js